<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Labels
 * Name: NotificationPointer
 */

defineOptions({
  name: 'NotificationPointer',
})

withDefaults(defineProps<NotificationPointer>(), {
  view: 'default',
  color: 'amber',
})

interface NotificationPointer {
  view?: 'default' | 'primary'
  color?: 'amber' | 'red'
}
</script>

<template>
  <div :class="['notification-pointer', `notification-pointer--${color}`]">
    <svg
      v-if="view === 'primary'"
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
    >
      <circle
        cx="3"
        cy="3"
        r="2.5"
        class="notification-pointer__ring"
        fill="currentColor"
      />
    </svg>
    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="6"
      viewBox="0 0 7 6"
      fill="none"
    >
      <circle
        cx="3.5"
        cy="3"
        r="3"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<style scoped lang="scss" src="./NotificationPointer.scss" />
